var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75.8 74.9",
    enableBackground: "new 0 0 75.8 74.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_2_",
    cx: 0.5832,
    cy: 73.0792,
    r: 132.6155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4EC55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#E48242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3463,
    style: {
      stopColor: "#D66863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4422,
    style: {
      stopColor: "#CD4F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    style: {
      stopColor: "#C94379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F56A6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1418_",
    fill: "url(#XMLID_2_)",
    d: "M38.2,72.8L38.2,72.8C18.4,72.8,2.4,56.8,2.4,37l0,0c0-19.8,16.1-35.9,35.9-35.9h0 C58,1.1,74.1,17.2,74.1,37l0,0C74.1,56.8,58,72.8,38.2,72.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1347_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1352_",
    fill: "#FFFFFF",
    d: "M38.2,20.9c5.3,0,5.9,0,7.9,0.1c1.9,0.1,3,0.4,3.7,0.7c0.9,0.4,1.6,0.8,2.3,1.5 c0.7,0.7,1.1,1.3,1.5,2.3c0.3,0.7,0.6,1.7,0.7,3.7c0.1,2.1,0.1,2.7,0.1,7.9c0,5.3,0,5.9-0.1,7.9c-0.1,1.9-0.4,3-0.7,3.7 c-0.4,0.9-0.8,1.6-1.5,2.3c-0.7,0.7-1.3,1.1-2.3,1.5c-0.7,0.3-1.7,0.6-3.7,0.7c-2.1,0.1-2.7,0.1-7.9,0.1c-5.3,0-5.9,0-7.9-0.1 c-1.9-0.1-3-0.4-3.7-0.7c-0.9-0.4-1.6-0.8-2.3-1.5c-0.7-0.7-1.1-1.3-1.5-2.3c-0.3-0.7-0.6-1.7-0.7-3.7c-0.1-2.1-0.1-2.7-0.1-7.9 c0-5.3,0-5.9,0.1-7.9c0.1-1.9,0.4-3,0.7-3.7c0.4-0.9,0.8-1.6,1.5-2.3c0.7-0.7,1.3-1.1,2.3-1.5c0.7-0.3,1.7-0.6,3.7-0.7 C32.4,20.9,33,20.9,38.2,20.9 M38.2,17.3c-5.3,0-6,0-8.1,0.1c-2.1,0.1-3.5,0.4-4.8,0.9c-1.3,0.5-2.4,1.2-3.5,2.3 c-1.1,1.1-1.8,2.2-2.3,3.5c-0.5,1.3-0.8,2.7-0.9,4.8c-0.1,2.1-0.1,2.8-0.1,8.1s0,6,0.1,8.1c0.1,2.1,0.4,3.5,0.9,4.8 c0.5,1.3,1.2,2.4,2.3,3.5c1.1,1.1,2.2,1.8,3.5,2.3c1.3,0.5,2.7,0.8,4.8,0.9c2.1,0.1,2.8,0.1,8.1,0.1c5.3,0,6,0,8.1-0.1 c2.1-0.1,3.5-0.4,4.8-0.9c1.3-0.5,2.4-1.2,3.5-2.3c1.1-1.1,1.8-2.2,2.3-3.5c0.5-1.3,0.8-2.7,0.9-4.8c0.1-2.1,0.1-2.8,0.1-8.1 s0-6-0.1-8.1c-0.1-2.1-0.4-3.5-0.9-4.8c-0.5-1.3-1.2-2.4-2.3-3.5c-1.1-1.1-2.2-1.8-3.5-2.3c-1.3-0.5-2.7-0.8-4.8-0.9 C44.3,17.3,43.6,17.3,38.2,17.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1349_",
    fill: "#FFFFFF",
    d: "M38.2,26.9c-5.6,0-10.1,4.5-10.1,10.1c0,5.6,4.5,10.1,10.1,10.1 c5.6,0,10.1-4.5,10.1-10.1C48.3,31.4,43.8,26.9,38.2,26.9 M38.2,43.5c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6 c3.6,0,6.6,2.9,6.6,6.6C44.8,40.6,41.9,43.5,38.2,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1348_",
    fill: "#FFFFFF",
    d: "M51.1,26.5c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C50,24.1,51.1,25.2,51.1,26.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.dc73f2e701a99e31e287b9b234ce0a8d.svg";
export { ForwardRef as ReactComponent };